import StyledSvgIconWrapper, { TStyledSvgIconWrapper } from "./wrappers/StyledSvgIconWrapper";

export const ServicesIcon = ({ monochrome, ...props }: TStyledSvgIconWrapper) => {
  return (
    <StyledSvgIconWrapper {...props} width="30" height="30" viewBox="0 0 30 30">
      <svg width="51" height="64" viewBox="0 0 51 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_105_17)">
          <path
            d="M17.29 45.95H30.26"
            stroke="#32B88E"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="stroke"
          />
          <path
            d="M17.29 37.98H41.74"
            stroke="#32B88E"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="stroke"
          />
          <path
            d="M17.29 29.94H41.74"
            stroke="#32B88E"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="stroke"
          />
          <path
            d="M39.76 10.37V6.84C39.76 4.17 37.45 2 34.61 2H7.15C4.31 2 2 4.17 2 6.84V48.79C2 51.46 4.31 53.63 7.15 53.63H10.08"
            stroke="#32B88E"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="stroke"
          />
          <path
            d="M48.34 19.27V15.21C48.34 12.54 46.03 10.37 43.19 10.37H15.73C12.89 10.37 10.58 12.54 10.58 15.21V57.16C10.58 59.83 12.89 62 15.73 62H43.19C46.03 62 48.34 59.83 48.34 57.16V19.27Z"
            stroke="#003939"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={monochrome ? "stroke" : undefined}
          />
        </g>
        <defs>
          <clipPath id="clip0_105_17">
            <rect width="50.34" height="64" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </StyledSvgIconWrapper>
  );
};
